import { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';

import { useAnalysisEditLock } from './useAnalysisEditLock';
import { useAnalysisRouteParams } from './useAnalysisRouteParams';
import type { UseVariablesPreviewSectionResult } from '../types';

// Owns the "Add variable" action + picker open-state for the "Analytical
// dataset" preview's variables section -- separate from useVariableSourceList,
// which owns the rows themselves, not adding a new one.
export const useVariablesPreviewSection = (): UseVariablesPreviewSectionResult => {
  const { formatMessage } = useIntl();
  const { projectId } = useAnalysisRouteParams();
  const { isEditDisabled, isProcessing } = useAnalysisEditLock();
  const [isPickerOpen, setIsPickerOpen] = useState(false);

  const onAddVariable = useCallback(() => setIsPickerOpen(true), []);
  const onClosePicker = useCallback(() => setIsPickerOpen(false), []);

  const editLockTooltip = isEditDisabled
    ? formatMessage({
        id: isProcessing
          ? 'analysisDetail.editLock.processing'
          : 'analysisDetail.editLock.notOwner',
      })
    : undefined;

  return {
    projectId,
    addLabel: formatMessage({ id: 'analysisDetail.tables.preview.addVariable' }),
    isPickerOpen,
    onAddVariable,
    onClosePicker,
    isEditDisabled,
    editLockTooltip,
  };
};
